import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { DatasetsUiActions } from '../state/actions';
import * as datasetsSelectors from '../state/selectors/datasets.selectors';
import { DatasetsState } from '../state/reducers/datasets.reducer';
import { IDatasetFile } from '../models/Dataset';

@Injectable({
  providedIn: 'root',
})
export class DatasetsFacade {
  datasetFiles$;
  selectedDatasetId$;
  selectedDataset$;

  datasetFilesSignal: Signal<IDatasetFile[] | null>;
  selectedDatasetIdSignal: Signal<number | null>;
  selectedDatasetSignal: Signal<IDatasetFile | null>;

  constructor(private store: Store<DatasetsState>) {
    this.datasetFiles$ = this.store.select(datasetsSelectors.datasetFiles);
    this.selectedDatasetId$ = this.store.select(datasetsSelectors.getSelectDatasetId);
    this.selectedDataset$ = this.store.select(datasetsSelectors.getSelectedDataset);

    this.datasetFilesSignal = toSignal(this.datasetFiles$, { initialValue: [] });
    this.selectedDatasetIdSignal = toSignal(this.selectedDatasetId$, { initialValue: null });
    this.selectedDatasetSignal = toSignal(this.selectedDataset$, {
      initialValue: null,
    });
  }

  public getDatasetFiles(projectId: number) {
    this.store.dispatch(DatasetsUiActions.GetDatasetFiles({ projectId }));
  }
  public setSelectedDatasetId(datasetId: number) {
    this.store.dispatch(DatasetsUiActions.SelectDatasetId({ datasetId }));
  }
  public clearSelectedDatasetId() {
    this.store.dispatch(DatasetsUiActions.ClearDatasetId());
  }

  public setSelectedDataset(dataset: IDatasetFile | null) {
    this.store.dispatch(DatasetsUiActions.SelectDataset({ dataset }));
  }

  public clearSelectedDataset() {
    this.store.dispatch(DatasetsUiActions.SelectDataset({ dataset: null }));
  }

  public postGrantDatasetAccess(datasetId: number, projectId: number) {
    this.store.dispatch(DatasetsUiActions.PostGrantDatasetAccess({ datasetId, projectId }));
  }

  public getAndSelectDataset(datasetId: number) {
    this.store.dispatch(DatasetsUiActions.GetDatasetById({ datasetId }));
  }
}
